module.exports = __webpack_public_path__ + "static/media/Dibots Logo 2.b6580dbc.png";